import CustomButton from "components/CustomButton/CustomButton";
import SpaceDialogAction from "../SpaceDialogAction";

const DialogCannotResponsibleTakeAttendanceUntilStartTime = ({
	dialog
}) => {
	return (
		<SpaceDialogAction
			dialog={dialog}
			title="No se puede tomar la asistencia"
			content="Recuerda que para tomar la asistencia de los estudiantes, la reserva debe haber iniciado.">
			<CustomButton
				width="120px"
				text="Cerrar"
				onClick={dialog.hide} />
		</SpaceDialogAction>
	);
}

export default DialogCannotResponsibleTakeAttendanceUntilStartTime;